var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#2362C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M495.652 253H596.119C609.826 253 622.089 260.959 626.874 272.961L715.058 494.148C715.739 495.854 715.747 497.731 715.081 499.443L714.587 500.714L714.582 500.726L626.769 726.524C622.054 738.646 609.726 746.716 595.923 746.716H495.471C489.822 746.716 485.862 741.506 487.724 736.523L578.271 494.148L487.946 263.299C485.989 258.297 489.952 253 495.652 253Z",
    fill: "#D631B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.393 253H333.86C347.567 253 359.83 260.959 364.614 272.961L452.799 494.148C453.479 495.854 453.487 497.731 452.822 499.443L452.327 500.714L452.322 500.726L364.509 726.524C359.795 738.646 347.467 746.716 333.664 746.716H233.212C227.563 746.716 223.603 741.506 225.465 736.523L316.012 494.148L225.687 263.299C223.73 258.297 227.693 253 233.393 253Z",
    fill: "#D631B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M563.826 447H422V554H563.826L587 498.971L563.826 447Z",
    fill: "#D631B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M553.652 253H654.119C667.826 253 680.089 260.959 684.874 272.961L773.058 494.148C773.739 495.854 773.747 497.731 773.081 499.443L772.587 500.714L772.582 500.726L684.769 726.524C680.054 738.646 667.726 746.716 653.923 746.716H553.471C547.822 746.716 543.862 741.506 545.724 736.523L636.271 494.148L545.946 263.299C543.989 258.297 547.952 253 553.652 253Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.393 253H391.86C405.567 253 417.83 260.959 422.614 272.961L510.799 494.148C511.479 495.854 511.487 497.731 510.822 499.443L510.327 500.714L510.322 500.726L422.509 726.524C417.795 738.646 405.467 746.716 391.664 746.716H291.212C285.563 746.716 281.603 741.506 283.465 736.523L374.012 494.148L283.687 263.299C281.73 258.297 285.693 253 291.393 253Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M621.826 447H480V554H621.826L645 498.971L621.826 447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlane);
export default __webpack_public_path__ + "static/media/hyperlane.61551ac8e6f58166f57e10225212a882.svg";
export { ForwardRef as ReactComponent };